<template>
  <el-dialog
    :visible.sync="visible"
    title="🚨 ALERTA DE GOLPE NO WHATSAPP"
    width="520px"
    custom-class="scam-alert-notice"
    append-to-body
    @close="persistDismissal"
  >
    <p>
      Estão utilizando o nome da Nogartel para enviar falsas cobranças e ameaças de protesto em
      cartório. <strong>Não pague nada e não clique em links!</strong>
    </p>
    <p>
      Nossos sistemas estão seguros. Já notificamos a META (WhatsApp) para que os números falsos
      sejam derrubados imediatamente.
    </p>
    <p>
      Em caso de dúvidas, fale conosco exclusivamente através do e-mail:
      <a href="mailto:sac@nogartel.com">sac@nogartel.com</a>.
    </p>
    <span slot="footer">
      <el-button type="primary" @click="visible = false">Entendi</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { partnerData } from '@/utils/partner'

// Scam alert requested by Nogartel (ticket #307): their SAC WhatsApp was cloned.
// Shown to every Nogartel (partner 10) user, with no end date, once per browser
// session (dismissal is kept in sessionStorage, so it shows again on the next visit).
// Remove this component when Nogartel asks to take the alert down.
const STORAGE_KEY = 'nogartelScamAlertNotice'
const NOGARTEL_PARTNER_ID = 10

export default {
  name: 'ScamAlertNotice',
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    const partner = partnerData()
    if (!partner || partner.partnerId !== NOGARTEL_PARTNER_ID) return
    if (this.alreadyDismissed()) return
    this.visible = true
  },
  methods: {
    alreadyDismissed() {
      try {
        return window.sessionStorage.getItem(STORAGE_KEY) === '1'
      } catch (e) {
        return false
      }
    },
    persistDismissal() {
      try {
        window.sessionStorage.setItem(STORAGE_KEY, '1')
      } catch (e) {
        // ignore storage errors (private mode, etc.)
      }
    }
  }
}
</script>

<style>
.scam-alert-notice.el-dialog {
  max-width: calc(100vw - 24px);
}
.scam-alert-notice .el-dialog__body {
  line-height: 1.6;
}
.scam-alert-notice .el-dialog__body p {
  margin: 0 0 12px;
}
</style>
